export const siteId = process.env.REACT_APP_BUILD_SITE;
export const ENABLED_ECOMMERCE_SITES = ['UBPE', 'ZPAR', 'CAPA', 'IWBR', 'WIBR'];
export const ENABLED_SHARE_COMMISSION_SITES = ['24MX'];

export const isPeru = ['UBPE', 'DVPE'].includes(siteId);
export const isBrazil = ['IWBR', 'CMBR', 'ICBR', 'WIBR'].includes(siteId);
export const isArgentina = ['ZPAR'].includes(siteId);

export const getEnabledEcommerceSites = () => {
  return ENABLED_ECOMMERCE_SITES.includes(siteId);
};

export const getEnabledShareCommissionSites = () => {
  return ENABLED_SHARE_COMMISSION_SITES.includes(siteId);
};

/**
 * Determines visibility and configuration for select sections in the publish step
 *
 * @param {Array} branches - Array of branch objects available for selection
 * @param {Array} users - Array of user objects that can be assigned as responsible
 * @param {Array} plans - Array of available plan objects
 * @param {string} postingStatus - Current status of the posting (e.g., 'DRAFT')
 *
 * @returns {Object} Configuration object with the following properties:
 * @returns {boolean} returns.showSelectSection - Whether to show the entire select section
 * @returns {boolean} returns.hideSelectBranches - Whether to hide the branch selection dropdown
 * @returns {boolean} returns.isUsersEmpty - Whether there are insufficient users to show selection
 * @returns {boolean} returns.isPlansEmpty - Whether there are no plans available
 * @returns {number|Object} returns.defaultUserId - Default user ID to pre-select
 * // Returns: { showSelectSection: false, hideSelectBranches: true, isUsersEmpty: false, isPlansEmpty: true, defaultUserId: 1 }
 */
export const showSelectSectionPublish = (branches = [], users = [], plans = []) => {
  const hideSelectBranches = branches.length === 0;
  const isUsersEmpty = users.length <= 1;
  const showSelectSection = !hideSelectBranches || !isUsersEmpty;
  const isPlansEmpty = plans.length === 0;
  const defaultUserId = users.length === 1 ? users[0].id : users.find(user => user.userTypeId === 1);

  return {
    showSelectSection,
    hideSelectBranches,
    isUsersEmpty,
    isPlansEmpty,
    defaultUserId
  };
};
